// @flow
import { Map } from "immutable"
import type { Dispatch } from "redux"
import {
  closeModal,
  reloadBookingAndCloseModal,
} from "mmb/scenes/AccountBooking/components/Booking/services"
import { cancelBooking } from "mmb/services/bookings/bookingsApi"
import { bidSelector } from "../../../services/selector"
// eslint-disable-next-line flowtype/no-weak-types
type GetState = () => Object

// CONSTANTS
const BOOKING_CANCELLATION_POST = "BOOKING_CANCELLATION_POST"
const BOOKING_CANCELLATION_POST_REQUEST = "BOOKING_CANCELLATION_POST_REQUEST"
const BOOKING_CANCELLATION_POST_SUCCESS = "BOOKING_CANCELLATION_POST_SUCCESS"
const BOOKING_CANCELLATION_POST_FAILURE = "BOOKING_CANCELLATION_POST_FAILURE"
const BOOKING_CANCELLATION_SET_INITIAL_STATE = "BOOKING_CANCELLATION_SET_INITIAL_STATE"

// REDUCER TYPES
type typeReducer = Map<{
  loading: boolean,
  success: boolean,
  error: string,
}>

type actionWithoutPayload = {|
  type: typeof BOOKING_CANCELLATION_POST,
  res?: any, // eslint-disable-line flowtype/no-weak-types
  payload?: Object, // eslint-disable-line flowtype/no-weak-types
  error?: string,
|}

// REDUCER’s INITIAL STATE
const INITIAL_STATE: typeReducer = Map({
  loading: false,
  success: false,
  error: null,
})

// REDUCER
export default function bookingCancellationReducer(
  state: typeReducer = INITIAL_STATE,
  action: actionWithoutPayload,
) {
  switch (action.type) {
    case BOOKING_CANCELLATION_POST_REQUEST:
      return state.set("loading", true)
    case BOOKING_CANCELLATION_POST_SUCCESS:
      return state.set("loading", false).set("success", true)
    case BOOKING_CANCELLATION_POST_FAILURE:
      return state.set("loading", false).set("error", action.error)
    case BOOKING_CANCELLATION_SET_INITIAL_STATE:
      return INITIAL_STATE
    default:
      return state
  }
}

// SELECTORS
export const isLoadingSelector = (
  state: any, // eslint-disable-line flowtype/no-weak-types
) => state.bookingCancellation.get("loading")

export const isSuccessSelector = (
  state: any, // eslint-disable-line flowtype/no-weak-types
) => state.bookingCancellation.get("success")

export const getErrorSelector = (
  state: any, // eslint-disable-line flowtype/no-weak-types
) => state.bookingCancellation.get("error")

export const setInitialStateAction = () => ({
  type: BOOKING_CANCELLATION_SET_INITIAL_STATE,
})

export const submitBookingCancellationAction = () => async (
  dispatch: Dispatch<any>,
  getState: GetState,
) => {
  const state = getState()
  const bid = bidSelector(state)

  const promise = cancelBooking(bid)

  const track = {
    bid,
  }

  await dispatch({
    type: BOOKING_CANCELLATION_POST,
    promise,
    _track: track,
    bid,
  })
}

export const closeCancellationAction = () => (dispatch: Dispatch<any>, getState: GetState) => {
  const state = getState()

  const isSuccess = isSuccessSelector(state)
  const hasError = getErrorSelector(state)

  if (isSuccess || hasError) {
    dispatch(reloadBookingAndCloseModal())
  } else {
    dispatch(closeModal())
  }

  dispatch(setInitialStateAction())
}
